import { Component, OnInit, Inject, EventEmitter, Output } from '@angular/core';
// import { DOCUMENT } from '@angular/platform-browser';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MarketService } from '../../shared/services/market.service';
import { inject } from '@angular/core/testing';
import { DOCUMENT } from '@angular/common';
import { UploadService } from '../../shared/services/upload.service';
import { UpserviceService } from '../../shared/services/upservice.service';
import { Auth } from 'aws-amplify';
import * as uuid from 'uuid';

@Component({
  selector: 'app-reg-page',
  templateUrl: './reg-page.component.html',
  styleUrls: ['./reg-page.component.css'],
  providers: [MarketService, UpserviceService]
})
export class RegPageComponent implements OnInit {

  public pageName: string = "register property";

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  ownerRegisterForm: FormGroup;
  sponsorRegisterForm: FormGroup;
  loginForm: FormGroup;
  public visible: boolean = true;
  public loginVisible: boolean;
  public clientVisible: boolean = false;


  selectedFiles: FileList;

  public isLoading: boolean;
  public errorMessage: string;
  public successMessage: string;
  public isSuccess: boolean;
  public showForm: string;
  public showTerm: string;
  public locationSelected;
  public imageName: string;
  public proposalName: string;
  public userGroup: string;
  public oid: any;
  public user_sub: any;
  public isTierOne: boolean;
  public isTierTwo: boolean;
  public isTierThree: boolean;
  public isTierFour: boolean;

  public sp_numbers = ["1", "2", "3", "4"];

  public locations = [
    'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
    'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape'
  ];

  public categories = [
    'Art', 'Music', 'Sport', 'Conference and Seminars', 'Nature and Wildlife', 'School Sponsorhip',
    'Food and Lifestyle', 'Festival', 'Fairs', 'Bespoke Events', 'Awards', 'Culture',
    'Broadcast', 'Individual', 'Alcohol'
  ];

  public months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ];

  public countries = ['South Africa'];

  public sponsor_financial: string = "Financial Sponsors";
  public sponsor_media: string = "Media Sponsors";
  public sponsor_inKind: string = "In-Kind Sponsors";
  public sponsor_promotional: string = "Promotional Sponsors";

  //s3://ganisponsormarket-all-purpose/Property Owners/image-fillers/


  public sponsorTierArray = [this.sponsor_financial, this.sponsor_media, this.sponsor_inKind, this.sponsor_promotional]

  financial = 1;
  media = 2;
  in_kind = 3;
  promotional = 4;
  public selectedSponsorTier = [];

  //list of all category properties
  careers = "Careers";
  youth = "Youth Focused";
  individual = "Individual";
  broadcast = "Broadcast";
  nature = "Nature and Wildlife";
  culture = "Culture";
  award = "Award";
  bespoke = "bespoke Event";
  festival = "Festival";
  expo = "Expo";
  food = "Food and Lifestyle";
  conference = "Conference and Seminars";
  sport = "Sport";
  music = "Music";
  public art = "Art";

  public categoryArrayList = [
    this.careers,
    this.youth,
    this.individual,
    this.broadcast,
    this.nature,
    this.culture,
    this.award,
    this.bespoke,
    this.festival,
    this.expo,
    this.food,
    this.conference,
    this.sport,
    this.music,
    this.art
  ];

  public selectedCategoryType = [];


  public testArr = [];
  displayErrorMessage: boolean;
  displaySuccessMessage: boolean;
  filename: string = "no file choosen";
  proposalFileName: string = 'no file choosen';

  public categoryA;
  public sponsors_tier;
  public random;
  public prop_uuid;
  public outside_uuid;

  public imageFile: any;
  public proposalFile: any;
  user_email: any;


  constructor(@Inject(DOCUMENT) private document: any, private fb: FormBuilder, private marketService: MarketService,
    private uploadService: UploadService, private upService: UpserviceService) {
    this.ownerRegisterForm = this.fb.group({
      name: ['', [Validators.required]], //Name
      description: ['', [Validators.required]], //Description
      industry: ['', [Validators.required]],
      // m_value: ['', [Validators.required]], //Sponsor Fees
      sp_name: ['', [Validators.required]], //Current Sponsors
      website: ['', [Validators.required]], //Property Website
      email: ['', [Validators.required, Validators.email]], //Email
      country: ['', [Validators.required]], //Country
      contact: ['', [Validators.required]], //Contact Number
      // amount: ['', [Validators.required]],
      category: ['', [Validators.required]], //Category
      location: ['', [Validators.required]], //Province
      date: ['', [Validators.required]], //Month
      duration: ['', [Validators.required]], //Duration
      attendance: ['', [Validators.required]], //Attendance No
      period: ['', [Validators.required]], //Year
      city: ['', [Validators.required]], //City
      image_url: ['', [Validators.required]],
      proposal_url: ['', [Validators.required]],
      sp_financial: [''],
      sp_media: [''],
      sp_inKind: [''],
      sp_promotional: [''],
      sponsor_number: ['', [Validators.required]],
      // sport_category: [''],
      m_value1: [''], m_value2: [''], m_value3: [''], m_value4: [''],
      start: ['', [Validators.required]], end: ['', [Validators.required]]
    });

    this.sponsorRegisterForm = this.fb.group({
      sp_name: ['', [Validators.required]],
      sp_industry: ['', [Validators.required]],
      category: ['', [Validators.required]],
      marketValue: ['', [Validators.required]],
      sp_province: ['', [Validators.required]],
      sp_period: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      contact: ['', [Validators.required]],
      market: ['', [Validators.required]],
      sp_region: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });

    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

    this.getCurrentAuthenticatedUser();
  }

  ngOnInit() {
    this.visible = true;
    this.isTierOne = true;

    console.log(' Paragraph ID ::: ', this.document.getElementById('filename'));

  } //ngOnInit Closing

  ngAfterViewInit() {
    this.ownerRegisterForm.controls['sp_financial'].valueChanges.subscribe(value => {
      if (!value) {
        this.remove(this.sponsor_financial);
      } else {
        this.selectedSponsorTier.push(this.sponsor_financial);
      }
    });

    this.ownerRegisterForm.controls['sp_media'].valueChanges.subscribe(value => {
      if (!value) {
        this.remove(this.sponsor_media);
      } else {
        this.selectedSponsorTier.push(this.sponsor_media);
      }
    });

    this.ownerRegisterForm.controls['sp_inKind'].valueChanges.subscribe(value => {
      if (!value) {
        this.remove(this.sponsor_inKind);
      } else {
        this.selectedSponsorTier.push(this.sponsor_inKind);
      }
    });

    this.ownerRegisterForm.controls['sp_promotional'].valueChanges.subscribe(value => {
      if (!value) {
        this.remove(this.sponsor_promotional);
      } else {
        this.selectedSponsorTier.push(this.sponsor_promotional);
      }
    });
  }

  public remove(topic: string) {

    if (this.selectedSponsorTier !== null) {
      var size = this.selectedSponsorTier.length;
      for (var x = 0; x < size; x++) {
        console.log(this.selectedSponsorTier[x]);
        if (this.selectedSponsorTier[x] == topic) {
          this.selectedSponsorTier.splice(x);
        }
      }
    }
  }

  getCurrentAuthenticatedUser() {
    const user = Auth.currentAuthenticatedUser()
      .then((user) => {
        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        this.user_sub = user.attributes.sub;
        this.user_email = user.attributes.email;

        console.log('user sub value ::: ', this.user_sub);

        console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]);
        console.log('header user', user);

      },
        (error) => {
          console.log("authentication error", error);

        });
  }

  uploadImage() {
    const file = this.imageFile;
    this.upService.uploadFile(file, this.user_sub, this.prop_uuid);
  }

  uploadTest() {
    const file = this.proposalFile;
    this.upService.uploadFileToS3(file, this.user_sub, this.prop_uuid);
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.imageName = this.selectedFiles.item(0).name;
    this.imageFile = this.selectedFiles.item(0);
    this.filename = this.imageName;
    console.log("Selected File: ", this.imageName);
    return this.imageName;
  }

  selectProposalFiles(event) {
    this.selectedFiles = event.target.files;
    this.proposalName = this.selectedFiles.item(0).name;
    this.proposalFile = this.selectedFiles.item(0);
    this.proposalFileName = this.proposalName;
    console.log("Selected File: ", this.proposalName);
    return this.proposalFileName;
  }

  sendPropertyConfirmationEmail(emailAddress: any, name: any) {
    var sendEmailObject = {
      "email": emailAddress,
      "propName": name
    };
    console.log("sendEmailObject", sendEmailObject);

    this.marketService.sendWelcomePropertyEmail(sendEmailObject).subscribe((data) => {
      console.log("sendWelcomeEmail Success", data);
    }, (error) => {
      console.log("sendWelcomeEmail Error", error);
    });
  }

  // console.log(JSON.stringify(event.target)); 

  public addSponsor() {

    this.isLoading = true;
    const spObject = {
      //Create Object 
      propName: this.sponsorRegisterForm.value.sp_name,
      industry: this.sponsorRegisterForm.value.sp_industry,
      propType: this.sponsorRegisterForm.value.category,
      image_url: this.imageName,
      propValue: this.sponsorRegisterForm.value.marketValue,
      province: this.sponsorRegisterForm.value.sp_province,
      period: this.sponsorRegisterForm.value.sp_period,
      email: this.sponsorRegisterForm.value.email,
      contact: this.sponsorRegisterForm.value.contact,
      market: this.sponsorRegisterForm.value.market,
      region: this.sponsorRegisterForm.value.sp_region,
      propDescription: this.document.getElementById('descript').value
    }

    // console.log(spObject); 
    this.marketService.addSponsor(spObject).subscribe((data) => {
      // console.log(data); 
      if (data.statusCode === 200) {
        this.sponsorRegisterForm.reset();
        this.isLoading = false;
        this.isSuccess = true;
        this.errorMessage = '';
        setTimeout(() => {
          this.successMessage = " Form Successfully Created "
        }, 300)
      } else {
        this.isLoading = false;
        this.errorMessage = data.message;
        if (this.errorMessage !== '') {
          this.errorMessage = " Please Fill all requiered Fields "
        }
      }
      err => {
        this.isLoading = false;
      }
    })

  }

  // getImageURL() {
  //   var alt_image = 'Property Owners/images-fillers/owner_image.png';
  //   var real_image = `Property Owners/${this.user_sub}/${this.outside_uuid}/${this.imageName}`; 
  //   var image; 

  //   if(image !== "") {
  //     image = real_image; 
  //   }
  //   else {
  //     image = alt_image
  //   }

  //   return image; 
  // }

  public addEvent() {

    // console.log('AddEvent () called !!!');
    // this.categoryA = this.document.querySelector('input[name="type"]'); 
    this.categoryA = this.document.getElementsByName('type');
    this.sponsors_tier = this.document.getElementsByName('sponsors');
    const myUuid = 'PROP-' + uuid.v4();
    this.outside_uuid = myUuid;
    var alt_image = 'Property Owners/images-fillers/owner_image.png';
    var real_image = `Property Owners/${this.user_sub}/${myUuid}/${this.imageName}`

    //s3://ganisponsormarket-all-purpose/Property Owners/image-fillers/
    //this.document.getElementById('filename') === null|| "" || undefined ? alt_image : real_image, 

    const marketObject = {
      name: this.ownerRegisterForm.value.name, //name
      status: 'NEW',
      type: this.getSelectedCheckboxValues(this.categoryA),
      industry: this.ownerRegisterForm.value.industry,
      noOfDays: this.ownerRegisterForm.value.duration, //duration
      onSiteAttendance: this.ownerRegisterForm.value.attendance, //attendance
      eventSite: this.ownerRegisterForm.value.country+" "+this.ownerRegisterForm.value.location+" "+this.ownerRegisterForm.value.city,
      category: this.ownerRegisterForm.value.category,

      description: this.ownerRegisterForm.value.category, //description
      image_url: `Property Owners/${this.user_sub}/${myUuid}/${this.imageName}`,
      // propValue: this.ownerRegisterForm.value.m_value, 
      sponsors: this.ownerRegisterForm.value.sp_name, //current sponsors
      website: this.ownerRegisterForm.value.website, //property website
      // spend: this.ownerRegisterForm.value.m_value, //sponsor fees
      period: this.ownerRegisterForm.value.period, //year 

      when: this.ownerRegisterForm.value.date,  //month
      region: this.ownerRegisterForm.value.location, //province
      email: this.ownerRegisterForm.value.email,  //email
      country: this.ownerRegisterForm.value.country, //country
      contact: this.ownerRegisterForm.value.contact, //contact
      city: this.ownerRegisterForm.value.city, //city
      sub: this.user_sub, //sub(cognito)
      // sp_tiers: this.getSponsorTierList() === "" ? "No Sponsors" : this.getSponsorTierList()
      sponsor_tier: this.getSponsorsTiers(this.sponsors_tier),
      sponsor_tier1Fee: this.ownerRegisterForm.value.m_value1 === "" ? "Null" : this.ownerRegisterForm.value.m_value1,
      sponsor_tier2Fee: this.ownerRegisterForm.value.m_value2 === "" ? "Null" : this.ownerRegisterForm.value.m_value2,
      sponsor_tier3Fee: this.ownerRegisterForm.value.m_value3 === "" ? "Null" : this.ownerRegisterForm.value.m_value3,
      sponsor_tier4Fee: this.ownerRegisterForm.value.m_value4 === "" ? "Null" : this.ownerRegisterForm.value.m_value4,
      start_date: this.ownerRegisterForm.value.start,
      end_date: this.ownerRegisterForm.value.end,
      sponsor_number: this.ownerRegisterForm.value.sponsor_number,
      proposal_url: `Property Owners/${this.user_sub}/${myUuid}/${this.proposalName}`,
      prop_id: myUuid,
      owner_id: "OWNER_ID-" + this.user_sub
    }

    const newPropertyObj = {
      name: this.ownerRegisterForm.value.name, //name
      description: this.ownerRegisterForm.value.category, //description
      attendance: this.ownerRegisterForm.value.attendance, //attendance
      type: this.getSelectedCheckboxValues(this.categoryA)[0],
      category: this.ownerRegisterForm.value.category,
      days: this.ownerRegisterForm.value.duration, //duration
      site: this.ownerRegisterForm.value.website, //property website
      industry: this.ownerRegisterForm.value.industry,
      // eventSite: this.ownerRegisterForm.value.country+" "+this.ownerRegisterForm.value.location+" "+this.ownerRegisterForm.value.city,
    }
    this.prop_uuid = marketObject.prop_id;

    // console.log("MarketObject ==> ", marketObject);
    console.log("newPropertyObj: ", newPropertyObj);
    console.log("this.ownerRegisterForm.value", this.ownerRegisterForm.value);
    

    if (this.ownerRegisterForm.valid) {
      this.isLoading = true;

      this.marketService.addProperty(newPropertyObj).subscribe((data) => {
        console.log("Subscribed data: ", data);
        if (data.result === 'success') {
          // this.prop_uuid = data.prop_id;
          this.sendPropertyConfirmationEmail(this.user_email, marketObject.name);
          this.uploadImage();
          // this.uploadTest();
          this.displaySuccessMessage = true;
          this.ownerRegisterForm.reset();
          this.resetFile();

          
          this.isSuccess = true;
          this.errorMessage = '';
          this.isLoading = false;
          this.successMessage = "You have successfully added you Property!";

        } else {
          this.isLoading = false;
          this.displayErrorMessage = true;
          this.errorMessage = data.message;
          if (this.errorMessage !== '') {
            this.errorMessage = "Error submitting your property!";
          }
        }
      }, err => {
        this.isLoading = false;
        console.log("Error: ", err);
      });
    }

  }

  resetFile() {
    const file: any = document.querySelector('.file');
    file.value = "";
    return file.value;
  };

  close() {
    this.document.body.style.overflow = 'visible';
    this.visible = false;
    this.visibleChange.emit(this.visible);
    setTimeout(() => {
      this.isSuccess = false;
      this.errorMessage = '';
      this.successMessage = '';
      this.ownerRegisterForm.reset();
    }, 1000);
  }

  onShowOwner() {
    this.visible = true;
    this.loginVisible = false;
    this.clientVisible = false;

    function clickButton() {
      document.getElementById('inactive').setAttribute("class", "testClass");
      // document.getElementById('navTab').setAttribute('class', 'register .nav-tabs');
    }
    function activateBtn() {
      document.getElementById('active').setAttribute('class', 'register .nav-tabs .nav-link.active');
      // document.getElementById('navTab').setAttribute('class', 'register .nav-tabs');
    }

    //  activateBtn(); 
    //  clickButton(); 
  }

  onShowClient() {
    this.clientVisible = true;
    this.visible = false;
    this.loginVisible = false;

    function clickBtn() {
      document.getElementById('inactive').setAttribute('class', 'register .nav-tabs .nav-link.active');
      // document.getElementById('navTab').setAttribute('class', 'register .nav-tabs'); 
    }

    function deactivateOwner() {
      document.getElementById('active').setAttribute('class', 'btnClass');
      // document.getElementById('navTab').setAttribute('class', 'register .nav-tabs');
    }

    // clickBtn(); 
    // deactivateOwner(); 

  }

  onShowLogin() {
    this.loginVisible = true;
    this.visible = false;
    this.clientVisible = false;


  }

  public getSponsorTierList() {
    var tiers = '';

    for (var x = 0; x < this.selectedSponsorTier.length; x++) {
      tiers += this.selectedSponsorTier[x] + " , ";

    }
    return tiers;
    console.log('Selected tiers ::: ', tiers);
  }

  getCategoryList() {
    var types = '';
    for (var x = 0; x < this.selectedCategoryType.length; x++) {
      types += this.selectedCategoryType[x] + ',';
    }
    return types;
    console.log('Selected category Types ::: ', types);
    // var cat = document.querySelectorAll("div.col-md-4 input");
    // const element = document.getElementById("art") as HTMLInputElement;
    // var checkedValue = null;
    // var inputElements = element;
    // for (var i = 0; inputElements[i]; ++i) {
    //   if (inputElements[i].checked) {
    //     checkedValue = inputElements[i].value;
    //     break;
    //   }
    // }
    // console.log('This is the Checked value ::: ', checkedValue); 
  }

  onChangeTierNumber() {
    console.log('OnKeyUp() function called !!!');
    console.log("The value is ::: ", this.ownerRegisterForm.value.sponsor_number)

    if (this.ownerRegisterForm.value.sponsor_number === 1) {
      this.isTierOne = true
      this.isTierTwo = false;
      this.isTierThree = false;
      this.isTierFour = false;
    }
    else if (this.ownerRegisterForm.value.sponsor_number === 2) {
      this.isTierTwo = true;
      this.isTierOne = false;
      this.isTierThree = false;
      this.isTierFour = false;
    }
    else if (this.ownerRegisterForm.value.sponsor_number === 3) {
      this.isTierThree = true;
      this.isTierTwo = false;
      this.isTierOne = false;
      this.isTierFour = false;
    }
    else if (this.ownerRegisterForm.value.sponsor_number === 4) {
      this.isTierFour = true;
      this.isTierOne = false;
      this.isTierTwo = false;
      this.isTierThree = false;
    }
  }

  testfx() {
    var sportCheck = this.document.getElementById('sport');
    var sportValue = this.ownerRegisterForm.value.sport_category;
    if (sportCheck.checked) {
      console.log('Sport CkeckBOX Checked !!! ==> ', sportValue);
    }
    else {
      console.log('Value is Null because Unckecked !!!!');
      //testing hmr
    }
  }

  getSponsorsTiers(sponsors: any) {
    console.log('getSponsorsTiers() called !!!');
    const checkboxes = document.querySelectorAll('input[name="sponsors"]:checked');
    let values = [];
    checkboxes.forEach((checkbox: HTMLInputElement) => {
      values.push(checkbox.value);
    })
    return values;
  }

  getSelectedCheckboxValues(type: any) {
    console.log('getSelectedCheckboxValues method called !!!');
    const checkboxes = document.querySelectorAll('input[name="type"]:checked');
    let values = [];
    checkboxes.forEach((checkbox: HTMLInputElement) => {
      values.push(checkbox.value);
    });
    return values;
  }

  //   var fileInput = document.querySelector('input[type=file]');
  // var filenameContainer = document.querySelector('#filename');
  // var dropzone = document.querySelector('div');

  // fileInput.addEventListener('change', function() {
  // 	filenameContainer.innerText = fileInput.value.split('\\').pop();
  // });

  // fileInput.addEventListener('dragenter', function() {
  // 	dropzone.classList.add('dragover');
  // });

  // fileInput.addEventListener('dragleave', function() {
  // 	dropzone.classList.remove('dragover');
  // });

}
